import React from "react";

/**
 * AllToMAIDIt mark: stylized "A" + integrated cross inside a broken circular ring.
 * Red A, cross + ring in the chosen mono tone. Christian cross stays subtle/integrated.
 */
export function LogoMark({ size = 36, mono = "#FFFFFF", red = "#FF0000", className = "" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" fill="none" className={className}
         role="img" aria-label="AllToMAIDIt">
      {/* broken circular ring (two arcs with gaps) */}
      <path d="M50 8 A42 42 0 0 1 92 50" stroke={red} strokeWidth="7" strokeLinecap="round" fill="none" />
      <path d="M92 50 A42 42 0 0 1 56 91.5" stroke={red} strokeWidth="7" strokeLinecap="round" fill="none" />
      <path d="M44 91.5 A42 42 0 0 1 8 50" stroke={mono} strokeWidth="7" strokeLinecap="round" fill="none" />
      <path d="M8 50 A42 42 0 0 1 44 8.5" stroke={mono} strokeWidth="7" strokeLinecap="round" fill="none" />
      {/* stylized A (red) */}
      <path d="M31 74 L47 26 L52 26 L45 47 L37 47 L34 57 L41 57 L35 74 Z" fill={red} />
      {/* integrated cross (mono) */}
      <rect x="57" y="30" width="8" height="46" fill={mono} />
      <rect x="47" y="45" width="28" height="8" fill={mono} />
    </svg>
  );
}

export function Logo({ dark = true, size = 34, showText = true }) {
  const mono = dark ? "#FFFFFF" : "#000000";
  return (
    <div className="flex items-center gap-2.5 select-none">
      <LogoMark size={size} mono={mono} />
      {showText && (
        <span className="font-display font-extrabold tracking-tight leading-none"
              style={{ color: mono, fontSize: size * 0.56 }}>
          AllTo<span style={{ color: "#FF0000" }}>MAID</span>It
        </span>
      )}
    </div>
  );
}
